/* Wide cards: a quiet icon at the 32px desktop target minimum */
button.perform {
  flex-shrink: 0;
  width: var(--tuna-spacing-4);
  height: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-0_5);
}

/* Phone: the 44px touch-target minimum (40 + 4) */
button.performCompact {
  width: calc(var(--tuna-spacing-5) + var(--tuna-spacing-0_5));
  height: calc(var(--tuna-spacing-5) + var(--tuna-spacing-0_5));
}
